import { NavigationEndpointConfig, NavigationEndpointOrder } from './constants';
import { NavigationEndpoint } from './types';

export const getNavItems = ({ broadcastId, eventId }: { broadcastId: string; eventId: string }) => {
  const sortedEndpoints = Object.entries(NavigationEndpointConfig).sort(
    ([e1], [e2]) =>
      NavigationEndpointOrder.indexOf(e1 as NavigationEndpoint) -
      NavigationEndpointOrder.indexOf(e2 as NavigationEndpoint)
  );
  return sortedEndpoints.map(([endpoint, config]) => ({
    ...config,
    href: `/${eventId}/${broadcastId}/${endpoint}`
  }));
};
